import { render, staticRenderFns } from "./Tinymce.vue?vue&type=template&id=47ded30a&scoped=true"
import script from "./Tinymce.vue?vue&type=script&lang=js"
export * from "./Tinymce.vue?vue&type=script&lang=js"
import style0 from "./Tinymce.vue?vue&type=style&index=0&id=47ded30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ded30a",
  null
  
)

export default component.exports